<template>
  <section :class="{ 'fill-landing': name !== '' }">    
    <Landing :booked="booked">
      <div class="ui">
        <Button v-if="name !== '' && !booked" link="#calendar" text="Book Now" @click="$store.state.availableBookings = []; $store.commit('setSelectedBooking', ''); $store.commit('setSelectedSchedule', 'sch-a');"/>
      </div>
    </Landing>    
    <Expired v-if="expired" />
    <Form v-else-if="name !== '' && !booked && showCalendar" />
  </section>
</template>

<script>
//<Button class="book" target="_blank" external v-show="name !== ''" :link="`mailto:${repEmail}`" :text="`Contact ${name}`"/>
import axios from "axios";
import Button from "@/components/Button";
import Landing from "@/components/Landing";
import Form from "@/components/Form";
import Expired from "@/components/Expired";
import Footer from "@/components/Footer";

export default {
  name: "Book",
  components: {
    Button,
    Landing,
    Form,
    Footer,
    Expired
  },
  data() {
    return {
      name: "",     
      repEmail:"",
      repPhone:"",
      repName:"",
      schedules:[] ,
      expired:false,
      booked:false,
      showRepInfo:false,
      showLocationInfo:false,
      photo:'',
      showCalendar:false
    };
  },
  created() {
     window.addEventListener('scroll', this.handleScroll);
    const params = new URLSearchParams();
    params.append("purl", this.$route.params.purl);
    params.append("appt", '');
    if (this.$route.query.group !== undefined) {
      params.append("group", String(this.$route.query.group));
    }
    if (this.$route.query.slot !== undefined) {
      params.append("slot", String(this.$route.query.slot));
    }
    axios
      .post(`${this.$store.state.API}/Purl.php`, params)
      .then(this.onGetPurl);
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    onGetPurl(response) {
      if (response.data.status === "ok") {
        this.name = response.data.first;        
        this.repEmail = response.data.repEmail; 
        this.repName = `${response.data.repFirst} ${response.data.repLast}`;
        let name = response.data.repLast.replaceAll(' ', '').toLowerCase();        
        this.photo = name;
        //${name.split(' ').unshift()
        this.repPhone = response.data.repPhone;        
        this.expired = response.data.expired;        
        this.booked = response.data.account?.booked ?? false;        
        this.$store.commit("setRepId", response.data.id);
        this.$store.commit("setRepPurl", response.data.repPurl);
        this.$store.commit("setClient", response.data.account ?? null);
        this.$store.commit("setPreloadSelection", response.data.requestedPosition ?? null);
        let schedules = response.data.schedules ?? []
        this.$store.commit("setSelectedSchedule", schedules[0].value ?? 'sch-a');
        this.showCalendar = true;        
      }
    },
    handleScroll (event) {
      if(window.scrollY === 0) {
        document.location.hash = '';
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.rep-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.85);
  display: grid;
  place-items: center;
  overflow: auto;
  z-index: 1;
   &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--blue);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--accent);
  }
  button {
    background:none;
    border:none;
    position: absolute;
    padding:1rem;
    top:0;
    right:0;
  }
  > div {    
    background: var(--blue);
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    font-size: 1rem;
    margin-top:56px;
    position: relative;
    min-width:300px;      
    @media (min-width:400px) {
      max-width:556px;      
      width:100vw
    }
  }
  p {
    color: var(--white);
    text-align: center;
    font-size: 34px;
    font-weight: 700;
    text-transform: uppercase;
    padding:0 30px;
  }
  img {
    width: 180px;
    position: relative;
    bottom:56px;
  }
  .rep-info {
    margin-top:-56px;
  }
  .contact-info {
    border-top:1px solid var(--red);
    margin:12px 30px;
    padding:26px 0;
    div, a {
      color: var(--white);
      text-align: center;
      font-size: 14px;
      font-weight: 700;
      text-decoration: none;
    }
    div {
      font-size: 1rem;
    }
    p {
      font-weight: bold;      
      line-height: 1;      
      font-size: 1.25rem;
    }
  }
}

.top-ui {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  color: var(--white);
  font-size: 1.25rem;
  margin: 0;
  padding: 1rem;
  display: flex;
  gap:5px;
  flex-direction: column;  
  width: 100%;  
  box-sizing: border-box;  
  .welcome {
    display: flex;
    gap:5px;
    flex-direction: column;
    margin: 0;
    align-items: stretch;
  }
    @media (min-width:600px) {
      flex-direction: row;
      width: unset;
      .welcome {
        flex-direction: row;
      }
    .book {    
      margin-top:36px;
    }  
  }
}
section {
  display: flex;
  flex-direction: column;
  &:not(.fill-landing) {
    min-height: 100vh;    
  }
  &.fill-landing {
    .landing {
      min-height: calc(max(100vh, 900px));
    }
  }
}
.ui {  
  margin-top:32px;  
  > * {
    margin:0;
  }
}
</style>